module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-html5-editor', {
    ref: "vueHtml5Editor",
    attrs: {
      "content": _vm.value || '',
      "auto-height": false,
      "height": _vm.height
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c42757"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/HtmlEditor.vue
// module id = 2562
// module chunks = 1